  <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
    <div class="bg-white">
      <p class="pb-3 heading-4">
        <span class="color-grey-700">{{label.form_title}}</span></p>
      <div class="row">
        <div class="col-md-6 col-12" *ngFor="let control of formData">
          <div class="mb-2" *ngIf="['text','password','email','number'].includes(control.type)">
            <div class="form-input">
              <label for="" class="input-label position-relative font-weight-600" *ngIf="control.name === dynamicFormIdentifiers.CODE">
                {{control.label}}
                <span *ngIf="control.validations.required">*</span>
              </label>
            </div>
            <div [ngClass]="{'country-dropdown-input' : control.name === dynamicFormIdentifiers.CODE}">
              <div class="single-dropdown hide-cross form-input" *ngIf="control.name === dynamicFormIdentifiers.CODE">
              <app-basic-multiselect-select
                [suggestionValue]="countryCodes" [selectedItems]="selectedItems" [selectedValues]="selectedCode"
                [suggestionList]="suggestionList" [dropdownSettings]="codeDropdownSettings" (emitOnItemSelect)="getSelectedCountry($event)">
              </app-basic-multiselect-select>
                <ng-template let-selectedCode #selectedItems>
                  <div class="text-left text-dark justify-content-start">
                    +{{selectedCode.code}}
                  </div>
                </ng-template>
                <ng-template let-countryCodes #suggestionList>
                  <div class="text-left justify-content-start">
                    +{{countryCodes.code}} {{countryCodes.name}}
                  </div>
                </ng-template>
              </div>
              <div class="form-input" [ngClass]="{'error': shouldShowErrors(dynamicForm.get(control.name))}"
                [class]="control.name !== dynamicFormIdentifiers.CODE ? 'w-100': ''">
                <label for="" class="input-label position-relative font-weight-600" *ngIf="control.name != dynamicFormIdentifiers.CODE">
                  {{control.label}}
                  <span *ngIf="control.validations.required">*</span>
                </label>
                <input class="input-field" [placeholder]="control.label" [value]="control.value" [type]="control.type"
                  [formControlName]="control.name"
                  [attr.maxLength]="control.validations.maxLength ? control.validations.maxLength : null"
                  (keypress)="control.name === dynamicFormIdentifiers.CODE ? mobileNumberValidation($event, control.validations): null">
              </div>
            </div>
            <small class="mt-n3" *ngIf="shouldShowErrors(dynamicForm.get(control.name))">
              <span class="color-error" *ngFor="let error of listOfError(dynamicForm.get(control.name), control.label)">
                {{error}}
              </span>
            </small>
          </div>
          <ng-container *ngIf="control.type === 'textarea'">
            <div class="form-textarea" [ngClass]="{'error': shouldShowErrors(dynamicForm.get(control.name))}">
              <textarea class="textarea-field" [placeholder]="control.label" [value]="control.value" [type]="control.type"
                [formControlName]="control.name"
                [attr.maxLength]="control.validations.maxLength ? control.validations.maxLength : null">
                </textarea>
                <p class="help-text" *ngIf="shouldShowErrors(dynamicForm.get(control.name))">
                  <span *ngFor="let error of listOfError(dynamicForm.get(control.name), control.label)">
                    {{error}}
                  </span>
                </p>
              </div>
          </ng-container>
        </div>
      </div>
      <div class="d-flex mt-3" *ngIf="disclaimer">
        <div class="pr-0">
          <img [src]="'assets/themes/icons/info-icon.svg'" alt="info"/>
        </div>

        <div class="col-11 pl-2 pr-0">
          <p class="secondary-paragraph pb-3 text-justify">
            <span class="color-grey-700" [innerHTML]="disclaimer | customLink"></span>
          </p>
        </div>
      </div>
      <div class="row justify-content-end mt-4">
        <div class="col-6 col-md-3 pr-0">
          <button class="btn-design medium outline" type="button" (click)="onReset()">
            {{label.reject}}
          </button>
        </div>
        <div class="col-6 col-md-3">
          <button [ngClass]="isConsentButtonDisabled || dynamicForm.invalid ? 'filled-disabled': 'filled'"
            class="btn-design medium" type="submit"
            [disabled]="isConsentButtonDisabled || dynamicForm.invalid">
            <span *ngIf="isConsentButtonDisabled" class="spinner-border spinner-border-sm mt-1" role="status"
              aria-hidden="true">
            </span>
            {{label.accept}}
          </button>
        </div>
      </div>
    </div>
  </form>